import React from 'react';

interface NavigationProps {
  back?: string;
  onBack?: () => void;
  backDisabled?: boolean;
  next?: string;
  onNext?: () => void;
  nextDisabled?: boolean;
}

export default function Navigation({
  back, next, onBack, onNext, backDisabled, nextDisabled,
}: NavigationProps) {
  const handleNext = () => {
    if (onNext) onNext();
  };

  const handleBack = () => {
    if (onBack) onBack();
  };

  return (
    <div className="recognition-navigation">
      <div className="recognition-navigation-left">
        {
          back && (
            <button type="button" className="btn btn-outline" onClick={handleBack} disabled={backDisabled === true}>{back}</button>
          )
        }
      </div>
      <div className="recognition-navigation-right">
        {
          next && (
            <button type="button" className="btn" onClick={handleNext} disabled={nextDisabled === true}>{next}</button>
          )
        }
      </div>
    </div>
  );
}
